export default {
      id: "calendar-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#calendar",
      toString: function () {
        return this.url;
      }
    }